import React from 'react'
import {
  ModalDescription,
  ModalContent,
  StyledRow,
  ModalItem,
  ModalTextItem,
  ModalSubtitle,
  CustomImage
} from './EnglishModal.styles'
import {
  modalDescription,
  modalSubDescription,
  FOUNTAS_AND_PINNELL_DESCRIPTION,
  CEFR_DESCRIPTION
} from './constants'
import type { LanguageTokens } from 'i18n'
import { useTranslation } from 'i18n'
import { Cdn } from 'utils/assets'

interface EnglishModalProps {
  onClose?: () => void
  isCEFR?: boolean
  isComparativeTable?: boolean
}

const EnglishModal: React.FC<EnglishModalProps> = ({
  onClose,
  isCEFR = false,
  isComparativeTable = false
}) => {
  const selectedLevelDescription = isCEFR
    ? CEFR_DESCRIPTION
    : FOUNTAS_AND_PINNELL_DESCRIPTION

  const { t } = useTranslation()

  return (
    <>
      {!isComparativeTable ? (
        <>
          <ModalDescription center isText>
            <p>
              {t(modalDescription(isCEFR))} {t(modalSubDescription)}
            </p>
          </ModalDescription>
          <ModalContent>
            {selectedLevelDescription.map(item => (
              <StyledRow key={item.title}>
                <div>
                  <ModalItem>
                    <ModalTextItem>
                      {t(item.title as LanguageTokens)}
                    </ModalTextItem>
                  </ModalItem>
                </div>
                <div>
                  <ModalSubtitle>
                    {t(item.subtitle as LanguageTokens)}
                  </ModalSubtitle>
                  <ModalDescription>
                    {t(item.description as LanguageTokens)}
                  </ModalDescription>
                </div>
              </StyledRow>
            ))}
          </ModalContent>
        </>
      ) : (
        <>
          <ModalDescription center>
            <p>
              {t(
                'Esta tabela traz as conversões para os níveis de leitura dos alunos entre os principais tipos de nivelamento de leitura.'
              )}
            </p>
          </ModalDescription>
          <ModalDescription center>
            <CustomImage
              src={Cdn.getImageUrl('running-records/tabela-comparativa.png')}
            />
          </ModalDescription>
        </>
      )}
    </>
  )
}

export default EnglishModal
